import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, IconButton, Tabs, Tab, MenuItem
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import colors from '../theme/Colors';

const sizeOptions = ['S', 'M', 'L', 'XL', '2XL', 'MIX'];

const ColorDialogTabs = ({
  open,
  onClose,
  onAddColor,
  existingColors = [],
  handleAddNew,
  colorDialog,
    setColorDialog,
    MenuProps = {},
}) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [newColor, setNewColor] = useState('');
  const [selectedColorId, setSelectedColorId] = useState('');

  const handleTabChange = (e, newValue) => {
    setTabIndex(newValue);
    setNewColor('');
    setSelectedColorId('');
  };

  const handleAdd = () => {
    let colorName = '';

    if (tabIndex === 0) {
      colorName = newColor.trim();
    } else if (tabIndex === 1) {
      const selectedColor = existingColors.find(c => c._id === selectedColorId);
      if (selectedColor) colorName = selectedColor.name.trim();
    }

    if (!colorName) return;

    const sizeMap = { color: colorName };
    sizeOptions.forEach(size => {
      sizeMap[size] = 0;
    });

    onAddColor(sizeMap);
    onClose();
    setNewColor('');
    setSelectedColorId('');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontSize: { xs: '1rem', sm: '1.2rem' }, position: 'relative' }}>
        Add Color
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8, color: 'black' }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Tabs value={tabIndex} onChange={handleTabChange} centered>
        <Tab label="Add New" />
        <Tab label="Add Existing" />
      </Tabs>
      <DialogContent sx={{ pt: 2 }}>
        {tabIndex === 0 ? (
          <TextField
            autoFocus
            label="Color Name"
            type="text"
            fullWidth
            value={colorDialog.name}
            onChange={(e) => setColorDialog(prev => ({ ...prev, name: e.target.value }))}
          />
        ) : (
            <TextField
            select
            label="Select Existing Color"
            fullWidth
            value={selectedColorId}
            onChange={(e) => setSelectedColorId(e.target.value)}
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  style: {
                    maxHeight: 250, // Set dropdown height
                    width: 250,     // Optional: dropdown width
                    overflowY: "auto",
                  },
                },
              },
            }}
          >
            {existingColors.map((color) => (
              <MenuItem key={color._id} value={color._id}>
                {color.name}
              </MenuItem>
            ))}
          </TextField>
        )}
      </DialogContent>

      <DialogActions sx={{
        p: { xs: 1, sm: 1.5 },
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 1, sm: 0 },
        justifyContent: 'flex-end',
      }}>
        <Button
          onClick={onClose}
          sx={{
            width: { xs: '100%', sm: 'auto' },
            fontSize: { xs: '0.75rem', sm: '0.875rem' }
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={tabIndex===0?handleAddNew:handleAdd}
          sx={{
            backgroundColor: colors.primary,
            color: 'black',
            '&:hover': {
              backgroundColor: '#FFC107',
              opacity: 0.9
            },
            width: { xs: '100%', sm: 'auto' },
            fontSize: { xs: '0.75rem', sm: '0.875rem' }
          }}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ColorDialogTabs;
